import { sendGetRequest, sendPostRequest } from './utils.js';
import { makeDraggable } from './windows.js';
import { updateAllPingsOnPage } from './pings.js';

export async function openDraggableTip(targetId) {
    // 1. Fetch content
    const response = await sendGetRequest(`/api/config/tips/${targetId}/`);
    const data = await response.json();
    const content = data.content;
    const title = data.title || targetId;

    // 2. Create or reuse container
    let tipWindow = document.getElementById(`tipWindow-${targetId}`);
    if (!tipWindow) {
        tipWindow = document.createElement('div');
        tipWindow.id = `tipWindow-${targetId}`;
        tipWindow.className = 'window window-draggable window-open';
        tipWindow.style.position = 'absolute';
        tipWindow.style.zIndex = '1000';
        tipWindow.style.left = '30%';
        tipWindow.style.top = '30%';

        tipWindow.innerHTML = `
            <div class="window-header">
                <span class="window-title">${title}</span>
                <div class="window-header-actions">
                    <button type="button" class="window-close">
                        <i class="icon-close-bold"></i>
                    </button>
                </div>
            </div>
            <div class="window-body">
                <div class="window-content"></div>
            </div>
        `;
        document.body.appendChild(tipWindow);

        const closeBtn = tipWindow.querySelector('.window-close');
        closeBtn.addEventListener('click', () => {
            tipWindow.classList.remove('window-open');
            tipWindow.remove();
        });

        const draggingContainer =
            document.querySelector('.disassembly-content-wrapper') ||
            document.body;
        makeDraggable(tipWindow, draggingContainer);
    } else {
        tipWindow.classList.add('window-open');
    }

    // 3. Inject content
    tipWindow.querySelector('.window-content').innerHTML = content;

    // 4. Mark as read
    try {
        await sendPostRequest('/api/notifications/mark_target_read/', {
            target_id: targetId,
        });
        await updateAllPingsOnPage();
    } catch (e) {
        console.error('Failed to mark tip as read:', e);
    }
}
